import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67438410&scoped=true&"
import script from "./code.js?vue&type=script&lang=js&"
export * from "./code.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=67438410&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67438410",
  null
  
)

export default component.exports